import { render, staticRenderFns } from "./BarCharts.vue?vue&type=template&id=32428c9c&scoped=true"
import script from "./BarCharts.vue?vue&type=script&lang=js"
export * from "./BarCharts.vue?vue&type=script&lang=js"
import style0 from "./BarCharts.vue?vue&type=style&index=0&id=32428c9c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32428c9c",
  null
  
)

export default component.exports